// WeChat contact helper for Forwaro's B2B inquiry flow.
// WeChat has no universal web deep-link like WhatsApp's wa.me, so the UI
// pattern is "show / copy the official WeChat ID".

const FORWARO_WECHAT_ID = "Forwaro1991";

/** The official Forwaro WeChat ID. */
export const getWeChatId = (): string => FORWARO_WECHAT_ID;

/** True once a real WeChat ID is configured. */
export const isWeChatConfigured = (): boolean => {
  const id = getWeChatId();
  return Boolean(id);
};

/** Copy the WeChat ID to the clipboard. Returns false if unavailable. */
export const copyWeChatId = async (): Promise<boolean> => {
  if (!isWeChatConfigured()) return false;
  try {
    await navigator.clipboard.writeText(getWeChatId());
    return true;
  } catch {
    return false;
  }
};
